import React from "react";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import getIntervalDates from "./Common/getIntervalDates";
import {
  PendingTimeoff,
  ScheduledSessions,
  ScheduledTimeoff,
  ScheduledTrips,
} from "./Common/Tags";
import { TIME_OFF_STATUS } from "./Common/constants";
import { updateUsers } from "../../../../../Redux/Slices/users.slice";

const Row = ({ startDate = "", endDate = "", driver }) => {
  const dispatch = useDispatch();

  const dates = getIntervalDates(startDate, endDate);

  const schedule = driver?.schedule ?? [];

  return (
    <div className="flex items-center w-full">
      <div className="w-[20%] bg-[#FCFCFC] py-[11px] h-[91px] px-6 flex items-center border-b border-light-grey">
        <p className="font-aileron font-semibold text-xs text-black capitalize">
          {driver?.name ?? ""}
        </p>
      </div>

      <div className="w-[80%] flex">
        {dates?.map((d) => {
          const current = schedule?.find((s) =>
            dayjs(s?.date).isSame(d, "day"),
          );

          const trips = current?.trips ?? [];
          const sessions = current?.sessions ?? [];

          const timeoff =
            current?.timeoffs?.find(
              (t) => t.status === TIME_OFF_STATUS.APPROVED,
            ) || null;

          const pendingTimeoff =
            current?.timeoffs?.find(
              (t) => t.status === TIME_OFF_STATUS.PENDING,
            ) || null;

          return (
            <div
              className={`w-full space-y-[7px] p-2 h-[91px] border-b border-l border-light-grey ${
                timeoff ? "cursor-pointer" : ""
              }`}
              style={{ background: timeoff ? "#DFDFDF" : "#FCFCFC" }}
              onClick={() => {
                if (timeoff) {
                  dispatch(
                    updateUsers({
                      key: "timeoffModal",
                      value: {
                        visible: true,
                        driver,
                        timeoff,
                        status: TIME_OFF_STATUS.APPROVED,
                      },
                    }),
                  );
                }
              }}
            >
              {timeoff ? (
                <ScheduledTimeoff data={{ driver, timeoff, date: d }} />
              ) : (
                <div className="w-full space-y-[7px]">
                  {trips.length ? (
                    <ScheduledTrips
                      count={trips.length}
                      data={{ driver, trips, date: d }}
                    />
                  ) : null}

                  {sessions.length ? (
                    <ScheduledSessions
                      count={sessions.length}
                      data={{ driver, sessions, date: d }}
                    />
                  ) : null}

                  {pendingTimeoff ? (
                    <PendingTimeoff
                      data={{
                        driver,
                        timeoff: pendingTimeoff,
                        date: d,
                      }}
                    />
                  ) : null}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Row;
